import React from 'react'

import Button from '@material-ui/core/Button'
import ClickAwayListener from '@material-ui/core/ClickAwayListener'
import Grow from '@material-ui/core/Grow'
import MenuList from '@material-ui/core/MenuList'
import Paper from '@material-ui/core/Paper'
import Popper from '@material-ui/core/Popper'

import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'

function SplitButton({
  title,
  options,
  onClick,
  children: childrenProp,
  ...rest
}) {
  const [open, setOpen] = React.useState(false)
  const [anchorEl, setAnchorEl] = React.useState(null)
  const children = React.Children.toArray(childrenProp).filter(
    menuItem => menuItem,
  )

  const handleClick = event => {
    setAnchorEl(event.currentTarget)
    setOpen(prevOpen => !prevOpen)
  }

  const handleClose = event => {
    setOpen(false)
  }

  return (
    <>
      {React.Children.count(children) > 0 ? (
        <>
          <ClickAwayListener onClickAway={handleClose}>
            <Button {...rest} onClick={handleClick}>
              <span>{title}</span>
              <ArrowDropDownIcon />
            </Button>
          </ClickAwayListener>
          <Popper
            open={open}
            anchorEl={anchorEl}
            transition
            placement="bottom-end"
          >
            {({ TransitionProps }) => (
              <Grow {...TransitionProps}>
                <Paper>
                  <MenuList style={{ minWidth: 200 }}>{children}</MenuList>
                </Paper>
              </Grow>
            )}
          </Popper>
        </>
      ) : null}
    </>
  )
}

SplitButton.defaultProps = {
  onClick: () => {},
}

export default SplitButton
